import { Skeleton } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { BsDot } from 'react-icons/bs'
import { TbSquareNumber1Filled, TbSquareNumber2Filled, TbSquareNumber3Filled } from 'react-icons/tb'
import useTitle from '../Hooks/useTitle';

const QrCode = () => {
    useTitle('QR Code');
    const { t } = useTranslation('qr_code');
    // const [loading, setLoading] = useState(false);
    const loading = false;

    return (
        <>
            <div className="grid gap-6  p-8  py-6   mt-[76px] sm:ml-[300px]">
                <div className=" items-center z-[1] ">
                    <span className='font-[600] text-[26px]'>{t("page_title")}</span>
                </div>
                {
                    loading ?
                        (
                            <div>
                                <div className="menuitem rounded-[20px]  cursor-pointer w-full ">
                                    <div className="div h-[600px] rounded-[20px] flex items-center">
                                        <Skeleton variant="rectangular" width="100%" className="rounded-[20px]" height="100%" />
                                    </div>
                                    <div className="p-2">
                                        <Skeleton width="70%" height={50} />
                                        <Skeleton width="60%" height={30} />
                                    </div>
                                </div>
                            </div>
                        ) :
                        (<div className=" bg-white p-6  flex flex-col gap-5 rounded-[20px]">
                            <div className="bg-[#F6F6F6] p-4 rounded-[9px] grid gap-6 ">
                                <div className='flex flex-col  gap-2 text-[14px] items-start'>
                                    <span className='text-[18px] font-[600] text-[#131415]'>{t("whats_the_qr_code")}</span>
                                    <p className='text-[#535861]'>{t("qr_code_description")}</p>
                                </div>
                                <div className='flex flex-col  gap-2 text-[14px] items-start'>
                                    <span className='text-[18px] font-[600] text-[#131415]'>{t("why_use_qr_code")} </span>
                                    <div className="flex">
                                        <span ><BsDot size={20} /></span>
                                        <p className='text-[#535861] '><span className='font-[600] text-[#131415]'> {t("easy_access_span")}</span>&nbsp;{t("easy_access")}</p>
                                    </div>
                                    <div className="flex">
                                        <span ><BsDot size={20} /></span>
                                        <p className='text-[#535861] '><span className='font-[600] text-[#131415]'>{t("save_time_span")} </span>&nbsp;{t("save_time")}</p>
                                    </div>
                                    <div className="flex">
                                        <span ><BsDot size={20} /></span>
                                        <p className='text-[#535861]  '><span className='font-[600] text-[#131415]'> {t("modern_interaction_span")} </span>&nbsp;{t("modern_interaction")} </p>
                                    </div>
                                </div>
                                <div className="bg-[#F6F6F6]  rounded-[9px] grid gap-3 ">
                                    <p className='font-[600] text-[#131415] text-[18px] ' >{t("how_to_download_qr")}</p>
                                    <div className='flex gap-2 text-[14px] items-start'>
                                        <span><TbSquareNumber1Filled fill='#3686FF' size={25} /></span>
                                        <p className='text-[#535861]'><span className='font-[600] text-[#131415]'> {t("step1_title")} </span>{t("step1_desc")}</p>
                                    </div>
                                    <div className='flex gap-2 text-[14px] items-start'>
                                        <span><TbSquareNumber2Filled fill='#3686FF' size={25} /></span>
                                        <p className='text-[#535861]'><span className='font-[600] text-[#131415]'> {t("step2_title")} </span>  {t("step2_desc")}</p>
                                    </div>
                                    <div className='flex gap-2 text-[14px] items-start'>
                                        <span><TbSquareNumber3Filled fill='#3686FF' size={25} /></span>
                                        <p className='text-[#535861]'><span className='font-[600] text-[#131415]'> {t("step3_title")} </span> {t("step3_desc")}</p>
                                    </div>
                                </div>
                                <div className="bg-[#F6F6F6]  rounded-[9px] grid gap-3 ">
                                    <p className='font-[600] text-[#131415] text-[18px] ' >{t("ideas_for_using_qr")} </p>
                                    <div className='flex gap-2 text-[14px] items-start'>
                                        <span><TbSquareNumber1Filled fill='#3686FF' size={25} /></span>
                                        <p className='text-[#535861]'><span className='font-[600] text-[#131415]'> {t("idea1_title")}</span> {t("idea1_desc")} </p>
                                    </div>
                                    <div className='flex gap-2 text-[14px] items-start'>
                                        <span><TbSquareNumber2Filled fill='#3686FF' size={25} /></span>
                                        <p className='text-[#535861]'><span className='font-[600] text-[#131415]'> {t("idea2_title")} </span>{t("idea2_desc")} </p>
                                    </div>
                                    <div className='flex gap-2 text-[14px] items-start'>
                                        <span><TbSquareNumber3Filled fill='#3686FF' size={25} /></span>
                                        <p className='text-[#535861]'><span className='font-[600] text-[#131415]'> {t("idea3_title")} </span>{t("idea3_desc")} </p>
                                    </div>

                                </div>
                            </div>
                        </div>
                        )
                }

            </div>
        </>
    )
}

export default QrCode